import React from 'react';
import PropTypes from 'prop-types';
import { Button, Column, Typography } from '@tempmee/react';
import { SessionScreen } from '../commonComponents/SessionScreen';

/**
 * Shown when the app starts with a stored session but cannot reach the server
 * to restore it. The session is kept, so Retry picks up where it left off;
 * sending the admin to the login screen here would throw away a session that
 * is still good.
 */
export const SessionUnreachable = ({ onRetry }) => (
  <SessionScreen>
    <Column gap={4} align="center">
      <Typography size="heading_4" bold>
        Can&apos;t reach the server
      </Typography>
      <Typography size="body_large">
        Your session is saved. Check your connection and try again.
      </Typography>
      <Button onClick={onRetry}>Retry</Button>
    </Column>
  </SessionScreen>
);

SessionUnreachable.propTypes = {
  onRetry: PropTypes.func.isRequired,
};

export default SessionUnreachable;
